module.exports = __webpack_public_path__ + "static/media/img157.26aef2f6.jpg";